import { GET_ADMIN_INTEGRATION_LOGS, GET_ADMIN_INTEGRATION_LOGS_ERROR, GET_ADMIN_INTEGRATION_LOGS_SUCCESS } from "./actionTypes"
import { buildCampaignAnalysisCacheKey } from "helpers/sf_utils"

const initialState = {
  error: null,
  admin_integration_logs: [],
  loading: null,
  has_next_page: false,
  has_lookahead_pages: false,
  lookahead_pages: [],
  last_page_fetched: 0,
  total_number_of_pages: 0,
  last_fetched_at: null,
  active_cache_key: null,
  page_cache: {},
}

const AdminIntegrationLogs = (state = initialState, action) => {
  switch (action.type) {
    case GET_ADMIN_INTEGRATION_LOGS:
      const queryParams = action.payload?.queryParams || {}
      const pageNumber = parseInt(queryParams.page_number, 10) || 1
      const isAppendRequest = Boolean(action.payload?.appendResults);
      const useCache = Boolean(action.payload?.useCache)
      const cacheKey = useCache ? buildCampaignAnalysisCacheKey(queryParams) : null
      const shouldResetCache =
        useCache &&
        pageNumber === 1 &&
        !isAppendRequest &&
        state.active_cache_key &&
        state.active_cache_key !== cacheKey
      const cachedPage = useCache ? state.page_cache?.[cacheKey]?.[pageNumber] : null
      return {
        ...state,
        admin_integration_logs: cachedPage?.rows || (isAppendRequest ? state.admin_integration_logs : []),
        loading: !cachedPage,
        active_cache_key: useCache ? cacheKey : null,
        has_next_page: typeof cachedPage?.has_next_page === 'boolean' ? cachedPage.has_next_page : state.has_next_page,
        has_lookahead_pages: typeof cachedPage?.has_lookahead_pages === 'boolean' ? cachedPage.has_lookahead_pages : state.has_lookahead_pages,
        lookahead_pages: cachedPage?.lookahead_pages || state.lookahead_pages,
        last_page_fetched: cachedPage?.page_number || state.last_page_fetched,
        total_number_of_pages: cachedPage?.total_number_of_pages || state.total_number_of_pages,
        page_cache: shouldResetCache ? {} : state.page_cache,
      }
    case GET_ADMIN_INTEGRATION_LOGS_SUCCESS:
      const currentPage = Number(action.payload?.additional_data?.page_number) || 1;
      const appendResults = Boolean(action.meta?.appendResults);
      const pageRows = Array.isArray(action.payload?.data) ? action.payload.data : []
      const pageSnapshot = {
        rows: pageRows,
        page_number: currentPage,
        total_number_of_pages: Number(action.payload?.additional_data?.total_number_of_pages) || 0,
        has_next_page: Boolean(action.payload?.additional_data?.has_next_page),
        has_lookahead_pages: action.payload?.additional_data?.has_lookahead_pages || false,
        lookahead_pages: action.payload?.additional_data?.lookahead_pages || [],
      }
      const successUseCache = Boolean(action.meta?.useCache)
      const successQueryParams = action.meta?.queryParams || {}
      const successCacheKey = successUseCache ? buildCampaignAnalysisCacheKey(successQueryParams) : null
      return {
        ...state,
        admin_integration_logs: appendResults ?
          [...state.admin_integration_logs, ...pageRows] :
          pageRows,
        has_next_page: action.payload?.additional_data?.has_next_page,
        has_lookahead_pages: action.payload?.additional_data?.has_lookahead_pages || false,
        lookahead_pages: action.payload?.additional_data?.lookahead_pages || [],
        last_page_fetched: currentPage,
        total_number_of_pages: Number(action.payload?.additional_data?.total_number_of_pages) || 0,
        last_fetched_at: new Date(),
        page_cache: successUseCache ? {
          ...state.page_cache,
          [successCacheKey]: {
            ...(state.page_cache?.[successCacheKey] || {}),
            [currentPage]: pageSnapshot,
          },
        } : state.page_cache,
        loading: false,
        error: null,
      }

    case GET_ADMIN_INTEGRATION_LOGS_ERROR:
      return {
        ...state,
        error: action.payload,
        admin_integration_logs: [],
        loading: false,
      }
    default:
      return state
  }
}

export default AdminIntegrationLogs
